import FileSaver from "file-saver";
import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";
import { handleErrors } from "./handleErrors";

const urlBase = `${process.env.API_URL}/client`;
const readUrl = (url = "") => `${urlBase}${url}`;

export const fetchClientesPaginados = async (params) => {
  const auth = `Bearer ${getToken()}`;

  const query = new URLSearchParams(params);
  let res = await fetch(readUrl(`?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const fetchAllClientes = async () => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl("/all"), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  res = await parseJSON(res);

  return res.success;
};
export const fetchCliente = async (params) => {
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl(`/${params.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  res = await parseJSON(res);

  return res.success;
};

export const importClientes = async () => {
  const auth = `Bearer ${getToken()}`;
  try {
    const res = await fetch(readUrl(`/generatecsv`), {
      method: "GET",
      headers: {
        Authorization: auth,
        "Content-Type": "application/json",
      },
    });
    if (!res.ok) {
      throw new Error(`Error al obtener el CSV: ${res.statusText}`);
    }
    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const filename = `PIN-Clientes.csv`;
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    return true;
  } catch (error) {
    handleErrors(error);
    return false;
  }
};
export const importRelevosClientes = async () => {
  const auth = `Bearer ${getToken()}`;
  const res = await fetch(readUrl(`/generaterelevoscsv`), {
    method: "GET",
    headers: {
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  const blob = await res.blob();

  const blobToCSV = (blobs) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const text = reader.result;

        const adjustedCSV = `SEP=,\n${text}`;
        resolve(adjustedCSV);
      };
      reader.onerror = reject;
      // Especificar la codificación de caracteres UTF-8 al leer el Blob como texto
      reader.readAsText(blobs, "UTF-8");
    });
  };

  try {
    // Convertir el Blob en texto CSV correctamente formateado
    const adjustedCSV = await blobToCSV(blob);

    const csvBlob = new Blob([adjustedCSV], { type: "text/csv;charset=UTF-8" });
    FileSaver.saveAs(csvBlob, "PIN-Relevos.csv");

    return true;
  } catch (error) {
    handleErrors(error);
    return false;
  }
};

export const getSubclientsByClientId = async (id) => {
  const auth = `Bearer ${getToken()}`;
  if (!id || id === "undefined") return [];

  let res = await fetch(readUrl(`/subclients/${id}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const getRegistroDeVisitas = async (params) => {
  const { id, ...restParams } = params;

  if (!id) return [];

  const auth = `Bearer ${getToken()}`;
  const query = new URLSearchParams(restParams).toString();

  let res = await fetch(readUrl(`/visita/${id}${query ? `?${query}` : ""}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const createRegistroDeVisita = async (data) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/visita/create`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  res = await parseJSON(res);
  return res.success;
};

export const updateRegistroDeVisita = async (id, data) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/visita/${id}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  res = await parseJSON(res);
  return res.success;
};

export const visitasKpis = async (params) => {
  const auth = `Bearer ${getToken()}`;

  const query = new URLSearchParams();
  query.append("startDate", params.startDate);
  query.append("endDate", params.endDate);

  let res = await fetch(readUrl(`/visita/kpi?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const exportRegistroDeVisitas = async (params) => {
  const auth = `Bearer ${getToken()}`;
  const query = new URLSearchParams(params);
  const res = await fetch(readUrl(`/visita/export?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  const blob = await res.blob();
  return blob;
};
